import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getAllAddon = createAsyncThunk('addon/getAllAddon', async ({ limit = 10, page = 1 }, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/admin/addons?limit=${limit}&page=${page}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getDetailAddon = createAsyncThunk('addon/getDetailAddon', async (params, thunkAPI) => {
  const { id, varietiesId, locationId, locTimeId, startDate, endDate, startTime, endTime } = params;

  let newUrl = `/addons/${id}/varieties/${varietiesId}`;

  if (locationId) {
    if (newUrl.includes('?')) {
      newUrl += `&location_id=${locationId}`;
    } else {
      newUrl += `?location_id=${locationId}`;
    }
  }

  if (locTimeId) {
    if (newUrl.includes('?')) {
      newUrl += `&loc_time_id=${locTimeId}`;
    } else {
      newUrl += `?loc_time_id=${locTimeId}`;
    }
  }

  if (startDate) {
    if (newUrl.includes('?')) {
      newUrl += `&start_booking_date=${startDate}`;
    } else {
      newUrl += `?start_booking_date=${startDate}`;
    }
  }

  if (endDate) {
    if (newUrl.includes('?')) {
      newUrl += `&end_booking_date=${endDate}`;
    } else {
      newUrl += `?end_booking_date=${endDate}`;
    }
  }

  if (startTime) {
    if (newUrl.includes('?')) {
      newUrl += `&start_booking_time=${startTime}`;
    } else {
      newUrl += `?start_booking_time=${startTime}`;
    }
  }

  if (endTime) {
    if (newUrl.includes('?')) {
      newUrl += `&end_booking_time=${endTime}`;
    } else {
      newUrl += `?end_booking_time=${endTime}`;
    }
  }

  try {
    const response = await axiosInstance.get(newUrl);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getOrderAddon = createAsyncThunk('orderAddon/getOrderAddon', async (transactionKey, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/orders/${transactionKey}/addons`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const createAddon = createAsyncThunk('addon/createAddon', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/admin/addons`,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPLOAD FILE IMAGE
export const uploadImageAddon = createAsyncThunk('addon/uploadImageAddon', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/addons/upload`,
      { file: payload },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data.file;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPLOAD FILE IMAGE
export const uploadImageAddonUpddate = createAsyncThunk(
  'addon/uploadImageAddonUpddate',
  async ({ payload, id }, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/addons/upload`,
        { file: payload },
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      return { data: response.data.file, id };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteAddon = createAsyncThunk('addon/deleteAddon', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/admin/addons/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPDATE ADDON
export const updateAddon = createAsyncThunk('addon/updateAddon', async (payload, thunkAPI) => {
  const { payloadData, addonId } = payload;

  try {
    const response = await axiosInstance.put(
      `/admin/addons/${addonId}`,
      { ...payloadData },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const getAllAddonByParams = createAsyncThunk('addon/getAllAddonByParams', async (params, thunkAPI) => {
  const { limit = 10, page = 1, locationId, locTimeId, startDate, endDate, startTime, endTime } = params;

  let newUrl = `/addons?limit=${limit}&page=${page}`;

  if (locationId) {
    newUrl += `&location_id=${locationId}`;
  }

  if (locTimeId) {
    newUrl += `&loc_time_id=${locTimeId}`;
  }

  if (startDate) {
    newUrl += `&start_booking_date=${startDate}`;
  }

  if (endDate) {
    newUrl += `&end_booking_date=${endDate}`;
  }

  if (startTime) {
    newUrl += `&start_booking_time=${startTime}`;
  }

  if (endTime) {
    newUrl += `&end_booking_time=${endTime}`;
  }

  try {
    const response = await axiosInstance.get(newUrl);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
